<template>
    <div class="register-describe-container">
        <h2>{{ $t('adNewQuestion.describe') }}</h2>
        <div class="describe-list">
            <div
                class="describe-item"
                v-for="item in describeList"
                :key="item.label"
                @click="handClick(item)"
            >
                <div class="describe-icon" v-html="item.img"></div>
                <div class="label">{{ item.label }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    i18next: {
        ns: 'common'
    },
    data: function() {
        return {
            leadType: {
                OWN: 'owner',
                RENT: 'rent'
            }
        };
    },
    computed: {
        describeList() {
            return [
                {
                    img: `<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_595_387)">
                                <path class="svgImg"
                                    d="M20 100H80C92.1 90.9 100 76.4 100 60C100 32.4 77.6 10 50 10C22.4 10 0 32.4 0 60C0 76.4 7.9 90.9 20 100Z"
                                    fill="#3B5CDE" fill-opacity="0.04" />
                                <path
                                    d="M50 71C52.2091 71 54 69.2091 54 67C54 64.7909 52.2091 63 50 63C47.7909 63 46 64.7909 46 67C46 69.2091 47.7909 71 50 71Z"
                                    fill="white" />
                                <path d="M59 84.4V100H41V84.4C41 79.2 45 75 50 75C55 75 59 79.2 59 84.4Z" fill="white" />
                                <path class="svgImg"
                                    d="M88.4998 61.4L52.7998 33C50.5998 31.2 47.3998 31.3 45.1998 33.1L34.9998 41.7V41C36.0998 41 36.9998 40.1 36.9998 39V37C36.9998 35.9 36.0998 35 34.9998 35H22.9998C21.8998 35 20.9998 35.9 20.9998 37V39C20.9998 40.1 21.8998 41 22.9998 41V51.7L11.1998 61.5C10.4998 62 10.2998 62.9 10.5998 63.7C10.8998 64.5 11.5998 65 12.4998 65H17.9998V94C17.9998 97.3 20.6998 100 23.9998 100H29.9998V89C29.9998 85.1 33.0998 82 36.9998 82C38.0998 82 39.1998 82.3 40.0998 82.7C39.9998 83.1 39.9998 83.6 39.9998 84V100H41.9998V84C41.9998 79.6 45.5998 76 49.9998 76C54.3998 76 57.9998 79.6 57.9998 84V100H59.9998V84C59.9998 83.6 59.9998 83.1 59.8998 82.7C60.7998 82.2 61.8998 82 62.9998 82C66.8998 82 69.9998 85.1 69.9998 89V100H75.9998C79.2998 100 81.9998 97.3 81.9998 94V65H87.2998C88.1998 65 88.8998 64.5 89.1998 63.7C89.4998 62.9 89.1998 62 88.4998 61.4ZM22.9998 37H34.9998V39H22.9998V37ZM32.9998 41V43.3L24.9998 50V41H32.9998ZM79.9998 94C79.9998 96.2 78.1998 98 75.9998 98H71.9998V89C71.9998 84 67.9998 80 62.9998 80C61.6998 80 60.4998 80.3 59.3998 80.7C58.0998 76.8 54.3998 74 49.9998 74C45.5998 74 41.8998 76.8 40.5998 80.7C39.4998 80.3 38.2998 80 36.9998 80C31.9998 80 27.9998 84 27.9998 89V98H23.9998C21.7998 98 19.9998 96.2 19.9998 94V63.6L48.3998 40.3C48.7998 40 49.2998 40 49.6998 40.3L79.9998 64.5V94ZM81.2998 63L50.8998 38.7C49.7998 37.8 48.1998 37.8 47.0998 38.7L17.5998 63H12.4998L46.4998 34.7C47.1998 34.1 48.0998 33.8 49.0998 33.8C49.9998 33.8 50.8998 34.1 51.5998 34.7L87.2998 63H81.2998ZM36.9998 68C34.1998 68 31.9998 70.2 31.9998 73C31.9998 75.8 34.1998 78 36.9998 78C39.7998 78 41.9998 75.8 41.9998 73C41.9998 70.2 39.7998 68 36.9998 68ZM36.9998 76C35.2998 76 33.9998 74.7 33.9998 73C33.9998 71.3 35.2998 70 36.9998 70C38.6998 70 39.9998 71.3 39.9998 73C39.9998 74.7 38.6998 76 36.9998 76ZM62.9998 78C65.7998 78 67.9998 75.8 67.9998 73C67.9998 70.2 65.7998 68 62.9998 68C60.1998 68 57.9998 70.2 57.9998 73C57.9998 75.8 60.1998 78 62.9998 78ZM62.9998 70C64.6998 70 65.9998 71.3 65.9998 73C65.9998 74.7 64.6998 76 62.9998 76C61.2998 76 59.9998 74.7 59.9998 73C59.9998 71.3 61.2998 70 62.9998 70ZM44.9998 67C44.9998 69.8 47.1998 72 49.9998 72C52.7998 72 54.9998 69.8 54.9998 67C54.9998 64.2 52.7998 62 49.9998 62C47.1998 62 44.9998 64.2 44.9998 67ZM49.9998 64C51.6998 64 52.9998 65.3 52.9998 67C52.9998 68.7 51.6998 70 49.9998 70C48.2998 70 46.9998 68.7 46.9998 67C46.9998 65.3 48.2998 64 49.9998 64Z"
                                    fill="#3B5CDE" />
                            </g>
                            <defs>
                                <clipPath id="clip0_595_387">
                                    <rect width="100" height="100" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>`,
                    label: this.$t('adNewQuestion.ownHome'),
                    key: this.leadType.OWN,
                    type: ['Homeowner']
                },
                {
                    img: `<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_595_382)">
                                <path class="svgImg"
                                    d="M20 100H80C92.1 90.9 100 76.4 100 60C100 32.4 77.6 10 50 10C22.4 10 0 32.4 0 60C0 76.4 7.9 90.9 20 100Z"
                                    fill="#3B5CDE" fill-opacity="0.04" />
                                <path d="M36 65H64C69 65 73 69 73 74C73 79 69 83 64 83H36C31 83 27 79 27 74C27 69 31 65 36 65Z" fill="white" />
                                <path class="svgImg"
                                    d="M88.4998 61.4L52.7998 33C50.5998 31.2 47.3998 31.3 45.1998 33.1L34.9998 41.7V41C36.0998 41 36.9998 40.1 36.9998 39V37C36.9998 35.9 36.0998 35 34.9998 35H22.9998C21.8998 35 20.9998 35.9 20.9998 37V39C20.9998 40.1 21.8998 41 22.9998 41V51.7L11.1998 61.5C10.4998 62 10.2998 62.9 10.5998 63.7C10.8998 64.5 11.5998 65 12.4998 65H17.9998V94C17.9998 97.3 20.6998 100 23.9998 100H40.9998V90H44.9998V100H46.9998V84H52.9998V100H54.9998V90H58.9998V100H75.9998C79.2998 100 81.9998 97.3 81.9998 94V65H87.2998C88.1998 65 88.8998 64.5 89.1998 63.7C89.4998 62.9 89.1998 62 88.4998 61.4ZM22.9998 37H34.9998V39H22.9998V37ZM32.9998 41V43.3L24.9998 50V41H32.9998ZM44.9998 88H40.9998V84H44.9998V88ZM35.9998 82C31.5998 82 27.9998 78.4 27.9998 74C27.9998 69.6 31.5998 66 35.9998 66H63.9998C68.3998 66 71.9998 69.6 71.9998 74C71.9998 78.4 68.3998 82 63.9998 82H35.9998ZM58.9998 88H54.9998V84H58.9998V88ZM79.9998 94C79.9998 96.2 78.1998 98 75.9998 98H60.9998V84H63.9998C69.4998 84 73.9998 79.5 73.9998 74C73.9998 68.5 69.4998 64 63.9998 64H35.9998C30.4998 64 25.9998 68.5 25.9998 74C25.9998 79.5 30.4998 84 35.9998 84H38.9998V98H23.9998C21.7998 98 19.9998 96.2 19.9998 94V63.6L48.3998 40.3C48.7998 40 49.2998 40 49.6998 40.3L79.9998 64.5V94ZM81.2998 63L50.8998 38.7C49.7998 37.8 48.1998 37.8 47.0998 38.7L17.5998 63H12.4998L46.4998 34.7C47.1998 34.1 48.0998 33.8 49.0998 33.8C49.9998 33.8 50.8998 34.1 51.5998 34.7L87.2998 63H81.2998ZM45.0998 74.6H48.7998V72.8H45.0998V71.4H49.2998V69.6H42.6998V78H49.3998V76.2H44.9998L45.0998 74.6ZM64.5998 78V71.5H67.1998V69.6H59.6998V71.5H62.2998V78H64.5998ZM56.3998 74.1L52.6998 69.6H50.6998V78H52.9998V73.5L56.6998 78H58.6998V69.6H56.3998V74.1ZM40.9998 74.3C41.2998 73.8 41.3998 73.3 41.3998 72.7C41.3998 72.1 41.1998 71.5 40.8998 71.1C40.5998 70.6 40.1998 70.3 39.5998 70C38.9998 69.7 38.3998 69.6 37.5998 69.6H33.7998V78H36.1998V75.8H37.4998L38.9998 78H41.4998L39.6998 75.4C40.2998 75.1 40.6998 74.8 40.9998 74.3ZM38.5998 73.6C38.3998 73.8 37.9998 73.9 37.4998 73.9H36.1998V71.4H37.4998C37.9998 71.4 38.3998 71.5 38.5998 71.7C38.7998 71.9 38.9998 72.2 38.9998 72.6C38.9998 73.1 38.8998 73.4 38.5998 73.6Z"
                                    fill="#3B5CDE" />
                            </g>
                            <defs>
                                <clipPath id="clip0_595_382">
                                    <rect width="100" height="100" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>`,
                    label: this.$t('adNewQuestion.rentHome'),
                    key: this.leadType.RENT,
                    type: ['Renter']
                }
            ];
        }
    },
    methods: {
        handClick(item) {
            this.$emit('change', item);
        }
    }
};
</script>

<style lang="scss" scope>
.register-describe-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    h2 {
        flex-shrink: 0;
        font-size: 24px;
        font-weight: 700;
        line-height: 30px;
        color: #191919;
        margin-bottom: 20px;
    }
    .describe-list {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        .describe-item {
            width: 100%;
            padding: 20px 0;
            text-align: center;
            border: 1px solid transparent;
            border-radius: 12px;
            cursor: pointer;
            .describe-icon {
                .svgImg {
                    fill: var(--color-theme);
                }
            }

            .label {
                font-size: 14px;
                font-weight: 500;
                line-height: 20px;
                color: #191919;
                margin-top: 30px;
            }
            &:hover,
            &.active {
                border-color: var(--color-theme);
            }
        }
    }
}
</style>
